import React from 'react';
import { useSelector } from 'react-redux';

import Dropdown from 'atoms/Dropdown';

import StyledStatusDropdown from './StyledStatusDropdown';

import StatusButtons from 'components/StatusButtons';

import { selectMatchEvents, selectShowStatusDropdown } from 'features/match/matchSlice';
import hasPenaltiesShootoutStarted from '../../helpers/hasPenaltiesShootoutStarted';

const StatusDropdown: React.FC = () => {
  const showStatusDropdown = useSelector(selectShowStatusDropdown);
  const matchEvents = useSelector(selectMatchEvents);
  const penaltiesShootoutStarted = hasPenaltiesShootoutStarted(matchEvents);

  /*
  @todo: This can be used for handball and ice hockey, but isn't necessary for football
  const dispatch = useDispatch();
  const matchStatusId = useSelector(selectMatchStatusId);

  const isMatchTimeStopped = useSelector(selectIsMatchTimeStopped);

  const notStartedOrEnded = matchStatusId === MatchStatus.NOT_STARTED || matchStatusId === MatchStatus.PLAYED;

  const StopMatchTimeButton = (
    <Button onClick={() => dispatch(matchActions.stopMatchTime())}>
      <FormattedMessage id="states.stop" />
    </Button>
  );
  const ResumeMatchTimeButton = (
    <Button onClick={() => dispatch(matchActions.resumeMatchTime())}>
      <FormattedMessage id="states.resume" />
    </Button>
  );
  */

  return (
    <Dropdown open={showStatusDropdown}>
      <StyledStatusDropdown>
        {/*!notStartedOrEnded && (isMatchTimeStopped ? ResumeMatchTimeButton : StopMatchTimeButton)*/}
        <StatusButtons all={true} penaltiesShootoutStarted={penaltiesShootoutStarted} />
      </StyledStatusDropdown>
    </Dropdown>
  );
};

export default StatusDropdown;
